/* eslint-disable unicorn/numeric-separators-style */
import { StoryData } from '@storyblok/react'
import { SEORobotsContent } from '@cinch-nx/data-storyblok'
import { ArticleStoryContent } from '../articles-story'

export const articlesFeatureStoryMock: StoryData<ArticleStoryContent> & {
  rels: unknown[] | undefined
} = {
  alternates: [],
  content: {
    _uid: '0e7b6e37-3196-47e8-a9ab-bedd70140ef2',
    component: 'ArticleTemplate',
    SEO: [
      {
        _uid: 'uuid-askldjf-jlkasd',
        component: 'SEO',
        title: 'SEO title',
        description: 'Some description',
        canonicalUrl: 'test/url',
        robots: ['all' as SEORobotsContent],
        twitterCard: [
          {
            _uid: 'uuid-askldjf-jlkasd',
            component: 'TwitterCard',
            card: 'card',
            title: 'test twitter image',
            description: 'this is a twitter image',
            imageUrl: '/imageurl',
            imageAlt: 'alt',
          },
        ],
      },
    ],
    body: {
      type: 'doc',
      content: [
        {
          type: 'paragraph',
          content: [
            {
              text: 'London, Friday 20 January 2023',
              type: 'text',
              marks: [
                {
                  type: 'bold',
                },
                {
                  type: 'styled',
                  attrs: {
                    class: '',
                  },
                },
              ],
            },
          ],
        },
        {
          type: 'paragraph',
          content: [
            {
              text: 'Virgin Radio UK today announces that The Chris Evans Breakfast Show has a new sponsor: cinch, the online used car marketplace. The three-year partnership commences on Monday 23rd January, with cinch the sole sponsor of the show.',
              type: 'text',
            },
          ],
        },
      ],
    },
    image: {
      id: 6_934_012,
      alt: 'Chris Evans Breakfast show - cinch',
      name: '',
      focus: null,
      title: '',
      filename:
        'https://a.storyblok.com/f/143588/3954x2636/089b6d83c2/cinch-cropped-2.jpg',
      copyright: '',
      fieldtype: 'asset',
    },
    quote: '',
    title:
      'cinch becomes new sponsor of The Chris Evans Breakfast Show  on Virgin Radio',
    video: [],
    authorByline: [
      {
        _uid: 'fb2abc69-a14f-4ab0-ba24-3fbd2fe63d2b',
        name: 'Ben Welham',
        image: {
          id: 17030422,
          alt: 'Ben Welham, car reviewer at cinch.co.uk',
          name: '',
          focus: '',
          title: 'Ben Welham, motoring journalist',
          source: '',
          filename:
            'https://a.storyblok.com/f/143588/1536x2048/21024488ad/ben-welham-author-pic-dynamic.JPG',
          copyright: '',
          fieldtype: 'asset',
          meta_data: {
            alt: 'Ben Welham, car reviewer at cinch.co.uk',
            title: 'Ben Welham, motoring journalist',
            source: '',
            copyright: '',
          },
          is_external_url: false,
        },
        component: 'AuthorByline',
        _editable:
          '\u003C!--#storyblok#{"name": "AuthorByline", "space": "143588", "uid": "fb2abc69-a14f-4ab0-ba24-3fbd2fe63d2b", "id": "214487563"}--\u003E',
      },
    ],
    subTitle:
      'The three-year partnership commences on Monday 23 January, with cinch the sole sponsor of the show.',
    leadParagraph: {
      type: 'doc',
      content: [
        {
          type: 'paragraph',
        },
      ],
    },
    relatedJargon: [],
    youtubeVideoId: '',
    originalPublishedDate: '',
  },
  created_at: '2023-06-13T10:22:03.076Z',
  full_slug:
    'articles/announcements/cinch-news/cinch-becomes-new-sponsor-of-the-chris-evans-breakfast-show-on-virgin-radio',
  group_id: '86d5a04c-20a6-4829-9121-f83953dda0e6',
  id: 323_575_917,
  is_startpage: false,
  meta_data: null,
  name: 'cinch becomes new sponsor of The Chris Evans Breakfast Show  on Virgin Radio',
  parent_id: 148_547_121,
  position: -10,
  published_at: '2023-06-13T10:22:03.134Z',
  first_published_at: '2023-01-20T10:00:00.000Z',
  slug: 'cinch-becomes-new-sponsor-of-the-chris-evans-breakfast-show-on-virgin-radio',
  lang: 'default',
  translated_slugs: [
    {
      path: 'path',
      name: 'name',
      lang: 'lang',
    },
  ],
  default_full_slug: 'default/slug',
  sort_by_date: null,
  tag_list: [],
  uuid: '0d0df8df-7619-43e6-a85e-eae025bfbbee',
  rels: [],
}
